import Header from 'components/headers/home'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import MobilePic from 'assets/images/home/Mobile_and_Notebook.svg'
import CalenderPic from 'assets/images/home/calender-icon.svg'
import Roadmap from 'assets/images/home/banner.svg'
import Headphone from 'assets/images/home/Headphone.svg'
import AccountNumber from 'assets/images/home/AccountNumber.svg'
import MoarefCode from 'assets/images/home/MoarefCode.svg'
import MiniCalender from 'assets/images/home/MiniCalender.svg'
import Wallet from 'assets/images/home/Wallet.svg'
import Faq from 'assets/images/home/Faq.svg'
import HowToStart from 'assets/images/home/HowToStart.svg'
import SuccessStory from 'assets/images/home/SuccessStory.svg'
import RulesAndConditions from 'assets/images/home/RulesAndConditions.svg'
import HamyanInMedia from 'assets/images/home/HamyanInMedia.svg'
import Arrow from 'assets/images/home/Arrow.svg'
import { getThisWeek } from 'utilities/helper/getThisWeek'
import classNames from 'classnames'
import { toast } from 'react-toastify'
import SupportModal from 'components/modals/supportModal'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
export default function HomePage() {
    const [openSupport, setOpenSupport] = useState<boolean>(false)
    const navigate = useNavigate()
    const week = getThisWeek()
    return (
        <>
            <Header title="همیان" />
            <SideBar>
                <SideBarItems />
            </SideBar>
            <img
                src={MobilePic}
                alt="mobile-home"
                className=" mx-auto w-full flex justify-center"
            />
            <div className=" bg-white text-sm mx-0 flex justify-between py-3 h-20 px-4 items-center">
                <div className=" bg-header-bg p-2 rounded-xl flex items-center">
                    <img src={CalenderPic} alt="clender" className="w-full" />
                </div>
                {week.map((item, index) => (
                    <div key={index} className=" text-center">
                        <p
                            className={classNames(
                                index === 0 && 'text-green-1'
                            )}
                        >
                            {item.day}
                        </p>
                        <p
                            className={classNames(
                                index === 0 && 'text-green-1'
                            )}
                        >
                            {item.name}
                        </p>
                    </div>
                ))}
            </div>
            <div className="my-3 flex justify-between bg-header-bg rounded-lg p-2 mx-3">
                <div>
                    <p>با کمک همیان، صندوق وام خودتو بساز!</p>
                    <p className=" text-xs text-gray-3">
                        فقط ۱۲ قدم تا صندوق وام ۳۰ میلیونی
                    </p>
                    <div
                        className=" bg-white rounded-full px-3 py-0.5 w-28 text-center text-xs shadow-[0_2px_40px_rgb(0,0,0,0.12)] mt-3"
                        onClick={() => toast.error('این صفحه در حال توسعه است')}
                    >
                        <p>شروع</p>
                    </div>
                </div>
                <img
                    src={Roadmap}
                    alt="Roadmap to build a 30m box"
                    className=""
                />
            </div>
            <div className="my-3  bg-white items-center text-center flex-col justify-center py-3">
                <div className=" my-2 grid grid-cols-11 mb-4 items-center">
                    <div className=" col-start-2 col-end-5 ">
                        <div
                            className=" cursor-pointer flex flex-col justify-center items-center"
                            onClick={() => setOpenSupport(true)}
                        >
                            <img
                                src={Headphone}
                                alt=""
                                className="bg-[#E3F1D9] p-3 rounded w-[12]! h-[12]!"
                            />
                            <p className=" text-sm">پشتیبانی</p>
                        </div>
                    </div>

                    <div className=" col-start-5 col-end-8 ">
                        <div
                            className="cursor-pointer flex flex-col justify-center items-center"
                            onClick={() => navigate('/manage-bank-cards')}
                        >
                            <img
                                src={AccountNumber}
                                alt=""
                                className="bg-[#E3F1D9] p-3 rounded w-[12]! h-[12]!"
                            />
                            <p className=" text-sm">مدیریت کارت‌‌ها</p>
                        </div>
                    </div>
                    <div className=" col-start-8 col-end-11">
                        <div
                            className=" cursor-pointer flex flex-col justify-center items-center"
                            onClick={() =>
                                window.location.replace(
                                    'https://hamyanapp.com/blog/faq/'
                                )
                            }
                        >
                            <img
                                src={Faq}
                                alt=""
                                className="bg-[#E3F1D9] p-3 rounded w-[12]! h-[12]!"
                            />
                            <p className=" text-sm">سوالات متداول</p>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-11 my-2">
                    <div
                        className=" col-start-2 col-end-5"
                        onClick={() => toast.error('این صفحه در حال توسعه است')}
                    >
                        <div className="flex flex-col justify-center items-center bg-white">
                            <img
                                src={MoarefCode}
                                alt=""
                                className="bg-[#E3F1D9] p-3 rounded w-[12]! h-[12]!"
                            />
                            <p className=" text-sm">کد معرف</p>
                        </div>
                    </div>

                    <div className=" col-start-5 col-end-8">
                        <div
                            className="cursor-pointer flex flex-col justify-center items-center"
                            onClick={() => navigate('/wallet')}
                        >
                            <img
                                src={Wallet}
                                alt=""
                                className="bg-[#E3F1D9] p-3 rounded w-[12]! h-[12]!"
                            />
                            <p className=" text-sm">کیف پول</p>
                        </div>
                    </div>
                    <div className="col-start-8 col-end-11">
                        <div
                            className="cursor-pointer flex flex-col justify-center items-center"
                            onClick={() =>
                                toast.error('این صفحه در حال توسعه است')
                            }
                        >
                            <img
                                src={MiniCalender}
                                alt=""
                                className="bg-[#E3F1D9] p-3 rounded w-[12]! h-[12]!"
                            />
                            <p className=" text-sm">تقویم</p>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <p className=" px-3 my-2">بیشتر بدانید:</p>
                <div
                    className=" cursor-pointer my-1"
                    onClick={() =>
                        window.location.replace(
                            'https://hamyanapp.com/how-to-use/'
                        )
                    }
                >
                    <div className="bg-white grid grid-cols-7 gap-2 py-2">
                        <div className="col-span-2 flex justify-start">
                            <img
                                src={HowToStart}
                                alt="How to start"
                                className="w-15 h-15"
                            />
                        </div>

                        <div className="col-span-4 flex text-center items-center justify-start">
                            <p className="">از کجا شروع کنم؟</p>
                        </div>

                        <div className="col-span-1 flex text-center items-center justify-start">
                            <img
                                src={Arrow}
                                alt="How to start arrow"
                                className=""
                            />
                        </div>
                    </div>
                </div>
                <div
                    className=" cursor-pointer my-1"
                    onClick={() => toast.error('این صفحه در حال توسعه است')}
                >
                    <div className="bg-white grid grid-cols-7 gap-2 py-2">
                        <div className="col-span-2 flex justify-start">
                            <img
                                src={SuccessStory}
                                alt="Success story"
                                className="w-15 h-15"
                            />
                        </div>

                        <div className="col-span-4 flex text-center items-center justify-start">
                            <p className="">داستان موفقیت صندوق‌ها</p>
                        </div>

                        <div className="col-span-1 flex text-center items-center justify-start">
                            <img
                                src={Arrow}
                                alt="Success story arrow"
                                className=""
                            />
                        </div>
                    </div>
                </div>
                <div
                    className=" cursor-pointer my-1"
                    onClick={() =>
                        window.location.replace('https://hamyanapp.com/policy/')
                    }
                >
                    <div className="bg-white grid grid-cols-7 gap-2 py-2">
                        <div className="col-span-2 flex justify-start">
                            <img
                                src={RulesAndConditions}
                                alt="Rules and conditions"
                                className="w-15 h-15"
                            />
                        </div>

                        <div className="col-span-4 flex text-center items-center justify-start">
                            <p className="">قوانین و مقررات</p>
                        </div>

                        <div className="col-span-1 flex text-center items-center justify-start">
                            <img
                                src={Arrow}
                                alt="Rules and conditions arrow"
                                className=""
                            />
                        </div>
                    </div>
                </div>
                <div
                    className=" cursor-pointer my-1"
                    onClick={() => toast.error('این صفحه در حال توسعه است')}
                >
                    <div className="bg-white grid grid-cols-7 gap-2 py-2">
                        <div className="col-span-2 flex justify-start">
                            <img
                                src={HamyanInMedia}
                                alt="Hamayan in media"
                                className="w-15 h-15"
                            />
                        </div>

                        <div className="col-span-4 flex text-center items-center justify-start">
                            <p className="">همیان در رسانه‌ها</p>
                        </div>

                        <div className="col-span-1 flex text-center items-center justify-start">
                            <img
                                src={Arrow}
                                alt="Hamyan in media arrow"
                                className=""
                            />
                        </div>
                    </div>
                </div>
            </div>
            <SupportModal
                show={openSupport}
                onHide={() => setOpenSupport(false)}
            />
        </>
    )
}
